export default {
  stockImages: []
}
